export const profilesKeys = {
  all: (...args) => ["profiles", ...args]
};
